const onKeyPressEnter = (e: any) => {
    // Enter wird unterbunden, damit das Formular nicht submitted wird
    if (e.key === 'Enter') {
        e.preventDefault();
    }
}

const InputEvents = {
    preventOnKeyPressEnter: onKeyPressEnter
}

export default InputEvents;